import {
  OAuthProviderType,
  ServerDeploymentType,
  ServerFeature,
} from '@hive/graphql';

import type { ServerConfig, ServerMetadata } from './types';

export const BUILD_IN_SERVERS: (ServerMetadata & { config: ServerConfig })[] =
  environment.isSelfHosted
    ? [
        {
          id: 'hive-cloud',
          baseUrl: location.origin,
          // selfhosted baseUrl is `location.origin`
          // this is ok for web app, but not for desktop app
          // since we never build desktop app in selfhosted mode, so it's fine
          config: {
            serverName: 'Hive Selfhost',
            features: [],
            oauthProviders: [],
            type: ServerDeploymentType.Selfhosted,
            credentialsRequirement: {
              password: {
                minLength: 8,
                maxLength: 32,
              },
            },
          },
        },
      ]
    : BUILD_CONFIG.debug
      ? [
          {
            id: 'hive-cloud',
            baseUrl: BUILD_CONFIG.isElectron
              ? 'http://localhost:8080'
              : location.origin,
            config: {
              serverName: 'Hive Cloud',
              features: [
                ServerFeature.Captcha,
                ServerFeature.Copilot,
                ServerFeature.OAuth,
                ServerFeature.Payment,
              ],
              oauthProviders: [OAuthProviderType.Google],
              type: ServerDeploymentType.Hive,
              credentialsRequirement: {
                password: {
                  minLength: 8,
                  maxLength: 32,
                },
              },
            },
          },
        ]
      : BUILD_CONFIG.appBuildType === 'stable'
        ? [
            {
              id: 'hive-cloud',
              baseUrl: 'https://app.joinhive.so',
              config: {
                serverName: 'Hive Cloud',
                features: [
                  ServerFeature.Captcha,
                  ServerFeature.Copilot,
                  ServerFeature.OAuth,
                  ServerFeature.Payment,
                ],
                oauthProviders: [OAuthProviderType.Google],
                type: ServerDeploymentType.Hive,
                credentialsRequirement: {
                  password: {
                    minLength: 8,
                    maxLength: 32,
                  },
                },
              },
            },
          ]
        : BUILD_CONFIG.appBuildType === 'beta'
          ? [
              {
                id: 'hive-cloud',
                baseUrl: 'https://insider.joinhive.so',
                config: {
                  serverName: 'Hive Cloud',
                  features: [
                    ServerFeature.Captcha,
                    ServerFeature.Copilot,
                    ServerFeature.OAuth,
                    ServerFeature.Payment,
                  ],
                  oauthProviders: [OAuthProviderType.Google],
                  type: ServerDeploymentType.Hive,
                  credentialsRequirement: {
                    password: {
                      minLength: 8,
                      maxLength: 32,
                    },
                  },
                },
              },
            ]
          : BUILD_CONFIG.appBuildType === 'internal'
            ? [
                {
                  id: 'hive-cloud',
                  baseUrl: 'https://insider.joinhive.so',
                  config: {
                    serverName: 'Hive Cloud',
                    features: [
                      ServerFeature.Captcha,
                      ServerFeature.Copilot,
                      ServerFeature.OAuth,
                      ServerFeature.Payment,
                    ],
                    oauthProviders: [OAuthProviderType.Google],
                    type: ServerDeploymentType.Hive,
                    credentialsRequirement: {
                      password: {
                        minLength: 8,
                        maxLength: 32,
                      },
                    },
                  },
                },
              ]
            : [
                // Default: use location.origin so deployment works on any domain
                {
                  id: 'hive-cloud',
                  baseUrl:
                    typeof location !== 'undefined'
                      ? location.origin
                      : 'https://hive.fail',
                  config: {
                    serverName: 'Hive Cloud',
                    features: [
                      ServerFeature.Captcha,
                      ServerFeature.Copilot,
                      ServerFeature.OAuth,
                      ServerFeature.Payment,
                    ],
                    oauthProviders: [OAuthProviderType.Google],
                    type: ServerDeploymentType.Hive,
                    credentialsRequirement: {
                      password: {
                        minLength: 8,
                        maxLength: 32,
                      },
                    },
                  },
                },
              ];
